import makeQueryKey from "../../utils/make-query-key";
var getGlobalConfigQueryKey = function getGlobalConfigQueryKey() {
  return makeQueryKey(['global-config']);
};
export default getGlobalConfigQueryKey;